<div class="tire-add-dialog">
  <div class="tire-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-tire font-20 font-gray-45 header-icon"></i>
        <div class="pl-1 tire-description width-100p p-relative">
          <p class="m-0 font-secondary-700 font-14" *ngIf="!tireId">Add new tire</p>
          <p class="m-0 font-secondary-700 font-14" *ngIf="tireId">{{ tire?.brand?.name }} - {{ tire?.model }}</p>
        </div>

        <!-- <app-switch-pill [disabled]="!!tireId && tire.stocked" id="tire-inventory-status" label="Inventory"
          position="end" styleClassLabel="font-gray-35" [fontSize]="12" [isActive]="tire.stocked"
          (appChange)="handleChange($event, 'stocked')">
        </app-switch-pill> -->
        <i id="tire-close-dialog" class="far fa-times pointer dialog-close" (click)="handleCloseModal()"></i>
      </div>
    </div>
  </div>

  <p-tabView class="tab-panel-underline tab-panel-estimates tab-panel-default" (onChange)="onTabSelect($event)">
    <p-tabPanel [selected]="selectedTab === 0">
      <ng-template pTemplate="header"> Basic info </ng-template>

      <ng-template pTemplate="content">
        <!-- Start Add Tire Body -->
        <div class="ui-g tire-body pt-0 pb-0 border-bottom-light">
          <div class="ui-g-12 inputs-column-spacing tire-inner-body" #partBody>
            <!-- Basic Info section -->
            <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0">
              <h5 class="input-heading font-14">Basic info</h5>

              <div class="ui-g-12 p-0 input-control-container">
                <!-- Brand -->
                <div class="ui-g-4 p-0 flex-start-center">
                  <div class="width-100p pl-1 pr-2">
                    <app-auto-complete id="tire-brand" placeholder="Brand" label="Brand" scrollHeight="198px"
                      editFieldLabel="Create brand" editableItemIdKey="_id" editFieldPlaceholder="Create brand"
                      [disabled]="isPartsTechItem" [autoFocus]="focus?.title" [fontSize]="14"
                      [theme]="errors?.brand ? 'primary' : 'light'" [floatingLabel]="true" [value]="tire?.brand?.name"
                      [isInvalid]="errors?.brand" [hasError]="errors?.brand" [listItemFontSize]="14"
                      [isSaveForFuture]="true" [hasFutureSelectionField]="false" [isDropdownIconVisible]="true"
                      [suggestions]="tagsSuggestion" [hasEditableField]="!isNewCategoriesEnabled"
                      (appFocus)="focus.brand = true" (appCompletedMethod)="handleTagSearch($event)"
                      (appClear)="handleClear('brand')" (appSelect)="handleSelect($event, 'brand')"
                      (appClickOutside)="focus.brand = false" (appSave)="handleCreateBrand($event)"
                      (appUpdateItem)="onUpdateItem($event, 'brand')">
                      <ng-template let-item let-editItem="editItem" appTemplate="item">
                        <div class="tag-item flex-between-center">
                          <div>
                            <span>{{ item?.name }}</span>
                          </div>
                          <div class="tag-item-action flex-end-center">
                            <i *ngIf="!isNewCategoriesEnabled" class="fas fa-pencil p-1 mr-2"
                              (click)="$event.stopPropagation(); editItem(item)"></i>
                          </div>
                        </div>
                      </ng-template>
                    </app-auto-complete>
                  </div>
                </div>

                <!-- Model -->
                <div class="ui-g-4 p-0 flex-start-center">
                  <!-- <div class="icon flex-center-start">
              <i class="far fa-tire height-icon"></i>
            </div> -->

                  <div class="tire-category width-100p pl-1 pr-2">
                    <app-input id="tire-model" placeholder="Model" [disabled]="isPartsTechItem"
                      [theme]="errors?.model ? 'primary' : 'light'" [floatingLabel]="true" [isInvalid]="errors?.model"
                      [value]="tire.model" [autoFocus]="true" (appFocus)="focus.model = true"
                      (appBlur)="handleBlur('model')" (appChange)="handleChange($event, 'model')">
                    </app-input>
                  </div>
                </div>

                <!-- PartsTech Item number -->
                <div class="ui-g-4 p-0 flex-start-center not-allowed read-only-field" *ngIf="isOnlineInvOrderEnabled">
                  <!-- <div class="icon flex-center-start">
              <i class="far fa-qrcode height-icon"></i>
            </div> -->

                  <div class="tire-category width-100p pl-1 pr-2">
                    <app-input id="tire-partstech-item-number" placeholder="Manufacturer Part Number" [disabled]="true"
                      theme="light" [floatingLabel]="true" [value]="tire?.partsTechId"> </app-input>
                  </div>
                </div>

                <!-- Categories -->
                <div class="ui-g-4 p-0 flex-start-center" *ngIf="isGlobalCategoryEnabled && !isNewCategoriesEnabled"
                  [ngClass]="{ 'mt-2 m-height-50': isOnlineInvOrderEnabled }">
                  <!-- <div class="icon flex-center-start">
              <i class="far fa-tags height-icon"></i>
            </div> -->

                  <div class="m-height-50 width-100p pl-1 pr-2">
                    <app-auto-complete id="tire-category" listId="tire-category-list" label="Category"
                      placeholder="Category" field="name" scrollHeight="180px" theme="light" editableItemIdKey="_id"
                      editFieldLabel="Create Category" [floatingLabel]="true" [hasEditableField]="true"
                      [hasFutureSelectionField]="false" [isShowError]="isShowError" [closeOnSelection]="true"
                      [isDropdownIconVisible]="true" [hasStaticUnassignedFiled]="false" [suggestions]="categoryResults"
                      [listItemFontSize]="14" [fontSize]="14" [value]="tire.category?.name || ''"
                      (appFocus)="showSuggestions('tags')" (appBlur)="handleBlur('category')"
                      (appUpdateItem)="onUpdateItem($event, categoryType)"
                      (appSelect)="handleSelect($event, 'category')" (appSave)="saveCategory($event)"
                      (appChange)="handleChangeCategory(config?.tags?.labor, $event)"
                      (appCompletedMethod)="searchSuggestionCategory($event, 'tags')"
                      (appClear)="onClearSuggestion('tags')">
                      <ng-template let-item let-editItem="editItem" appTemplate="item">
                        <div class="tag-item flex-between-center">
                          <div>
                            <span>{{ item?.name }}</span>
                          </div>
                          <div class="tag-item-action flex-end-center">
                            <i class="fas fa-pencil p-1 mr-2" [hidden]="item?.nameSort === 'unassigned'"
                              (click)="$event.stopPropagation(); item?.nameSort === 'unassigned' ? return : editItem(item)"></i>
                            <i class="fa fa-trash p-1 mr-2" [hidden]="item?.nameSort === 'unassigned'"
                              (click)="$event.stopPropagation(); item?.nameSort === 'unassigned' ? return : deleteCategoryDialog(item)"></i>
                          </div>
                        </div>
                      </ng-template>
                    </app-auto-complete>
                  </div>

                </div>
              </div>

              <!-- Vendor/Supplier -->
              <div class="ui-g-4 p-0 flex-start-center" [ngClass]="{ 'mt-2 m-height-50': isOnlineInvOrderEnabled }">
                <div class="m-height-50 width-100p pl-1 pr-2">
                  <app-auto-complete id="tire-supplier" listId="tire-supplier-list" placeholder="Supplier"
                    label="Supplier" scrollHeight="198px" editFieldLabel="Create supplier"
                    editFieldPlaceholder="Create supplier" theme="light" [disabled]="isPartsTechItem" [fontSize]="14"
                    [isSaveForFuture]="true" [floatingLabel]="true" [hasFutureSelectionField]="false"
                    [value]="tire?.vendor?.name" [listItemFontSize]="14" [isDropdownIconVisible]="true"
                    [suggestions]="vendorsSuggestion" [hasEditableField]="true"
                    (appCompletedMethod)="handleVendorSearch($event)" (appClear)="handleClear('vendor')"
                    (appSelect)="handleSelect($event, 'vendor')" (appSave)="handleCreateSupplier($event)">
                    <ng-template let-item let-editItem="editItem" appTemplate="item">
                      <div class="tag-item flex-between-center">
                        <div>
                          <span>{{ item?.name }}</span>
                        </div>
                        <div class="tag-item-action flex-end-center">
                          <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                        </div>
                      </div>
                    </ng-template>
                  </app-auto-complete>
                </div>
              </div>

              <!-- Tire type -->
              <div class="ui-g-4 p-0 flex-start-center mt-2 m-height-50">
                <div class="m-height-50 width-100p pl-1 pr-2">
                  <app-auto-complete id="tire-type" listId="tire-type-list" placeholder="Tire type" label="Tire type"
                    scrollHeight="198px" theme="light" [fontSize]="14" [floatingLabel]="true"
                    [hasFutureSelectionField]="false" [value]="tire?.tireType?.name" [listItemFontSize]="14"
                    [isDropdownIconVisible]="true" [suggestions]="tireTypeSuggestion" [hasEditableField]="false"
                    (appCompletedMethod)="handleTireTypeSearch($event)" (appClear)="handleClear('tireType')"
                    (appSelect)="handleSelect($event, 'tireType')">
                  </app-auto-complete>
                </div>
              </div>

              <!-- Sales Code -->
              <div *ngIf="isNewCategoriesEnabled && isSalesCodeEnabled"
                class="ui-g-4 p-0 flex-start-center not-allowed mt-2" tooltipPosition="top"
                tooltipStyleClass="tooltip-width-medium text-center"
                [pTooltip]="!canEditClassifications && !isOpenFromRO ? classificationPrivilegeMsg : (tire?.salesCode?.title === 'Unassigned' || !tire?.salesCode?.title) ? 'Click here to assign sales code' : ''">

                <div class="tire-category width-100p pl-1 pr-2">
                  <app-input id="sales-code" type="text" placeholder="Sales Code" theme="primary" [fontSize]="14"
                    [rightIcon]="!tire?.salesCode?.shortName ? 'fas fa-plus-circle font-warning pointer' : ''"
                    [imgIcon]="tire?.salesCode?.shortName ? 'assets/img/icon/edit-outline.svg' : ''"
                    imgIconClass="pointer" (iconClicked)="openAssignSalesCodeDialog()" name="sales-code"
                    [value]="displaySalesCodeTitle()" [floatingLabel]="true" [maxLength]="50" [disabled]="true">
                  </app-input>
                </div>

              </div>
            </div>
            <!-- Basic info section ends -->

            <!-- Item classification -->
            <div *ngIf="isNewCategoriesEnabled" class="input-basic-info-wrapper input-default-style ui-g-12 p-0">
              <h5 class="input-heading">
                Item classification <span><i class="fas fa-info-circle"></i></span>
              </h5>


              <div class="ui-g-12 p-0 input-control-container" tooltipPosition="top"
                tooltipStyleClass="tooltip-width-medium text-center"
                [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
                <!-- add flag here -->
                <app-category-search subId="1" [type]="'tire'" [placeholder]="'Search category'"
                  [canEditClassifications]="canEditClassifications"
                  (appSelect)="onSelectCategory($event)"></app-category-search>
              </div>

              <div class="ui-g-12">
                <div class="ui-g-4" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
                  [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
                  <app-auto-complete id="standard-category" listId="standard-category-list" field="categoryName"
                    label="Standard Category" placeholder="Standard Category" scrollHeight="186px" theme="light"
                    [value]="tire.category?.categoryName" [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="true"
                    [listItemFontSize]="13" [disabled]="!canEditClassifications"
                    [suggestions]="categoriesSuggestionsResults" [isDropdownIconVisible]="true"
                    [isLoading]="loader?.category" (appFocus)="handleFocus('category')"
                    (appBlur)="handleBlur('category')" (appSelect)="categoryDropdownSelect('category', $event)"
                    (appCompletedMethod)="onSearchItem('category', $event)" (appClear)="handleClear('category')">
                  </app-auto-complete>
                </div>
                <div class="ui-g-4" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
                  [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
                  <app-auto-complete id="standard-subcategory" listId="standard-subcategory-list"
                    field="subCategoryName" label="Standard Subcategory" placeholder="Standard Subcategory"
                    scrollHeight="186px" theme="light" [value]="tire.category?.subCategoryName" [fontSize]="14"
                    [listItemFontSize]="14" [floatingLabel]="true" [listItemFontSize]="13"
                    [suggestions]="subCategoriesSuggestionsResults" [isDropdownIconVisible]="true"
                    [disabled]="!tire.category?.categoryId || !canEditClassifications"
                    (appFocus)="handleFocus('subCategory')" (appBlur)="handleBlur('subCategory')"
                    [isLoading]="loader?.subCategory" (appSelect)="categoryDropdownSelect('subCategory', $event)"
                    (appCompletedMethod)="onSearchItem('subCategory', $event)"
                    (appClear)="handleClear('subCategory')"></app-auto-complete>
                </div>
                <div class="ui-g-4" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
                  [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
                  <app-auto-complete id="standard-Part-Type" listId="standard-part-type-list" field="subSubCategoryName"
                    label="Standard Part Type" placeholder="Standard Part Type" scrollHeight="186px" theme="light"
                    [value]="tire.category?.subSubCategoryName" [fontSize]="14" [listItemFontSize]="14"
                    [floatingLabel]="true" [listItemFontSize]="13"
                    [disabled]="!tire.category?.subCategoryId || !canEditClassifications"
                    [suggestions]="subSubCategoriesSuggestionsResults" [isDropdownIconVisible]="true"
                    [isLoading]="loader?.subSubCategory" (appFocus)="handleFocus('subSubCategory')"
                    (appBlur)="handleBlur('subSubCategory')"
                    (appSelect)="categoryDropdownSelect('subSubCategory', $event)"
                    (appCompletedMethod)="onSearchItem('subSubCategory', $event)"
                    (appClear)="handleClear('subSubCategory')"></app-auto-complete>
                </div>
              </div>
            </div>
            <!-- Item classification end -->

            <!-- Seasonality Info section -->
            <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0" style="margin-bottom: 20px">
              <div class="ui-g-12 p-0 input-control-container">
                <div class="ui-g-12 p-0 flex-start-center">
                  <!-- <div class="icon flex-center-start mt-3">
              <i class="far fa-sun-cloud height-icon"></i>
            </div> -->

                  <div class="width-100p pl-1">
                    <h5 class="font-11 font-gray-45 mb-1">Seasonality</h5>

                    <div class="ui-g-12 p-0 seasonality-wrapper" [ngClass]="{ 'not-allowed': isPartsTechItem }">
                      <div class="ui-g-3 p-1 seasonality-tab text-center pointer"
                        [ngClass]="{ active: tire.seasonality === 'summer' }"
                        (click)="isPartsTechItem ? null : handleChange('summer', 'seasonality')">
                        <i class="far fa-sun font-gray-35"></i>
                        <span class="pl-6p">Summer</span>
                      </div>

                      <div class="ui-g-3 p-1 seasonality-tab text-center pointer"
                        [ngClass]="{ active: tire.seasonality === 'winter' }"
                        (click)="isPartsTechItem ? null : handleChange('winter', 'seasonality')">
                        <i class="far fa-cloud-snow font-gray-35"></i>
                        <span class="pl-6p">Winter</span>
                      </div>

                      <div class="ui-g-3 p-1 seasonality-tab text-center pointer"
                        [ngClass]="{ active: tire.seasonality === 'all' }"
                        (click)="isPartsTechItem ? null : handleChange('all', 'seasonality')">
                        <i class="far fa-cloud-sun-rain font-gray-35"></i>
                        <span class="pl-6p">All seasons</span>
                      </div>

                      <div class="ui-g-3 p-1 seasonality-tab text-center pointer"
                        [ngClass]="{ active: tire.seasonality === 'allWeather' }"
                        (click)="isPartsTechItem ? null : handleChange('allWeather', 'seasonality')">
                        <i class="far fa-cloud-sun-rain font-gray-35"></i>
                        <span class="pl-6p">All Weather</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Seasonality Info section ends -->

            <!-- Size section -->
            <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0 mt-3">
              <h5 class="input-heading font-14">Sizes</h5>
              <div class="ui-g-12 p-0 input-control-container">
                <app-tire-size *ngFor="let size of tire.sizes; let sizeIndex = index" [tireId]="tireId"
                  [isPassThroughTaxEnable]="isPassThroughTaxEnable" [isTireConnectConnected]="isTireConnectConnected"
                  [isMarkAsInventoryEnabled]="isMarkAsInventoryEnabled" [isBrandFocusChange]="focus?.brand"
                  [isModelFocusChange]="focus?.model" [isFeeAssociationEnabled]="isFeeAssociationEnabled"
                  [previousTitle]="size?.previousTitle" [previousTitleFR]="size?.previousTitleFR" [openFrom]="openFrom"
                  [isOpenFromRO]="isOpenFromRO" [isQTQAddOnEnable]="isQTQAddOnEnable" [averageCost]="averageCost"
                  [latestPoCost]="latestPoCost" [isCommissionPlanEnabled]="isCommissionPlanEnabled"
                  [locations]="locations" [isQboConnected]="isQboConnected" [isPartsTechItem]="isPartsTechItem"
                  [isOpenFromPO]="isOpenFromPO" [isInventoryEnabled]="isInventoryEnabled" [tire]="tire"
                  [updateGenericItem]="updateGenericItem" [orderServiceId]="orderServiceId"
                  [errors]="tire?.errors[sizeIndex] || {}" [pricings]="pricings" [pricingRules]="pricingRules"
                  [isOpenFromST]="isOpenFromST" [qboItemRefs]="qboItemRefs" [itemResults]="itemResults"
                  [isSearching]="isSearching" [index]="sizeIndex" [size]="size"
                  [showLoaderTireconnect]="showLoaderTireconnect" [defaultQboItemRefs]="defaultQboItemRefs"
                  [isPricingMatricesManagement]="isPricingMatricesManagement"
                  [isNewItemCategoriesEnable]="isNewItemCategoriesEnable"
                  [isAttributeBasedPricingEnable]="isAttributeBasedPricingEnable"
                  [isPricingManagementEnable]="isPricingManagementEnable" (selectFee)="onROSelect($event)"
                  (searchHazmatFee)="searchSuggestion($event)" (addNewFee)="addAnotherFee(sizeIndex)"
                  (appDeleteTireSize)="handleDeleteTireSize($event)" (appCheckForUniqueTitle)="checkUniqueTitle($event)"
                  (removeFee)="removeHazmatFee($event)" (updatedField)="onFieldUpdateOnSize($event)"
                  (appAssociateFETFee)="getFetFee(sizeIndex)"
                  (apponTooltipIconClicked)="getFETRatefromTireConnect(sizeIndex)"
                  [isFromTireAdd]="true"
                  >
                </app-tire-size>
              </div>
              <div class="ui-g-12 p-0 mt-1">
                <p class="mt-1 mb-1 font-primary font-600 pointer"
                  *ngIf="!poDetails?.poId && !tireId && tire?.sizes?.length < 5" (click)="handleAddSize()">Add another
                  tire size</p>
              </div>
            </div>
            <!-- Size section ends-->
          </div>
        </div>
        <!-- Start Add Tire Body ends -->

        <!-- Start Add Parts Footer -->
        <div class="ui-g-12 flex-between-center dialog-footer part-footer p-0">
          <div class="part-add-dialog-footer d-flex justify-content-between width-100p">
            <div>
              <app-checkbox *ngIf="isAutoLeapItem && (orderServiceId || isOpenFromPO) && tireId && !isOpenFromMO"
                inputId="cb-part-add-another" label="Also update tire across application"
                [isChecked]="updateGenericItem" [disabled]="isPricingManagementEnable && !isPricingMatricesManagement && (tire?.isChangeInPriceMatrix || isChangeInPriceMatrix)"
                tooltipPosition="top" tooltipStyleClass="tooltip-width-200"
                [pTooltip]="isPricingManagementEnable && !isPricingMatricesManagement && (tire?.isChangeInPriceMatrix || isChangeInPriceMatrix) ? 'Current pricing is different from default. Please contact admin / store manager to update' : ''"
                (appChange)="updateGenericItem = $event; tire.sizes[0].status = defaultActiveState">
              </app-checkbox>
              <span *ngIf="isOpenFromMO" class="width-100p">
                You can only update tire location from this modal
              </span>
            </div>

            <div>
              <button class="btn btn-border pointer btn-submit mr-1" (click)="handleCloseModal()">Cancel</button>
              <button class="btn btn-primary btn-submit" tooltipPosition="top"
                [pTooltip]="isLockedRO ? 'Sorry, cannot make any changes to a Locked RO':isFinalizedRo ? 'Sorry, cannot make any changes to a finalized RO' : ''"
                [disabled]="isProcessing || isFinalizedRo || isLockedRO" (click)="handleSubmit()">
                <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
                <i *ngIf="isProcessing" class="far fa-spinner rotate"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- End Add Parts Footer -->
      </ng-template>
    </p-tabPanel>

    <p-tabPanel [selected]="selectedTab === 1">
      <ng-template pTemplate="header"> Activity logs </ng-template>
      <ng-template pTemplate="content">
        <div class="activity-logs">
          <div class="catalog-activity-wrapper">
            <!-- Activity logs -->
            <div *ngIf="activityLogs?.length" class="catalog-activity-inner-wrapper">
              <div *ngFor="let activityLog of activityLogs">
                <app-catalog-activity-logs [activityLog]="activityLog"></app-catalog-activity-logs>
              </div>
            </div>

            <div *ngIf="!activityLogs?.length" class="catalog-activity-inner-wrapper no-activity-logs p-3">
              <p>There are no activity logs.</p>
            </div>

            <!-- Filter wrapper -->
            <div class="filter-ddl-wrapper">
              <div class="dropdown">
                <div class="btn dropdown-toggle" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  Filter &nbsp;
                  <i *ngIf="isFilterLoading" class="fal fa-spinner rotate"></i>
                  <span *ngIf="filterOption?.length" class="filter-count-bubble">{{ selectedFilterOptionLength }}</span>
                </div>

                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                  <ul class="catalog-list-filter">
                    <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                      <app-checkbox label="Item history" [isChecked]="filterOptionModel.itemHistory" [fontSize]="12"
                        (appChange)="onCheckboxChange($event, 'catalog-item')"> </app-checkbox>
                    </li>
                    <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                      <app-checkbox label="Pricing history" [isChecked]="filterOptionModel.pricingHistory"
                        [fontSize]="12" (appChange)="onCheckboxChange($event, 'item-pricing')">
                      </app-checkbox>
                    </li>
                    <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                      <app-checkbox label="Purchase history" [isChecked]="filterOptionModel.purchaseHistory"
                        [fontSize]="12" (appChange)="onCheckboxChange($event, 'ci-purchase-history-po')">
                      </app-checkbox>
                    </li>
                    <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                      <app-checkbox label="Selling history" [isChecked]="filterOptionModel.sellingHistory"
                        [fontSize]="12" (appChange)="onCheckboxChange($event, 'ci-sale-history-ro')"> </app-checkbox>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>